import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface supplier {
    id: number;
    name: string;
    account_no: number;
    serial_no: number;
    phone: string;
    email: string;
}
interface iSupplier {[key:number]:supplier[]}

// Suppliers state
export interface suppliersState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    suppliers: iSupplier,
    page:number
}

const initialSuppliersState: suppliersState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    suppliers: {},
    page:1
}

// Suppliers slice
export const suppliersSlice = createSlice({
    name: 'suppliers',
    initialState: initialSuppliersState,
    reducers: {
        init:(state,{payload}:PayloadAction<supplier[]>)=>{
            state.suppliers[state.page]=payload
        },
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        addSuppliers: ( state, {payload}: PayloadAction<supplier[]> ) => {
            state.suppliers[state.page] = state.suppliers[state.page]?
            [ ...state.suppliers[state.page], ...payload ]:[...payload]
        },
        updateSupplier: ( state, {payload}: PayloadAction<supplier> ) => {
            let index = state.suppliers[state.page].findIndex( supplier => supplier.id === payload.id )
            if( index !== -1 )
            state.suppliers[state.page][index] = payload
        },
        deleteSuppliers: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.suppliers[state.page].findIndex( supplier => supplier.id === id )
                if( index != -1 )
                    state.suppliers[state.page].splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.suppliers = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})